export default __webpack_public_path__ + "static/media/logo-side-icon.0adf614b.svg";